// plugins is a alias. see client/build/webpack.base.conf.js
// import http client
import { http } from '@/plugins/http/index';
import { getData } from '@/utils/get';

export const getTabs = () => http.get('apiToolbar/getTabs').then(getData);

export const getActiveLocationMenu = () => http.post('apiToolbar/getActiveLocationsMenu', {}).then(getData);

export const submitActiveLocation = (payload) => http.post('apiToolbar/submitActiveLocation', payload).then(getData);